import { render, staticRenderFns } from "./NeedsMealsTable.vue?vue&type=template&id=c08ca5f6&scoped=true&lang=pug"
import script from "./NeedsMealsTable.vue?vue&type=script&lang=ts"
export * from "./NeedsMealsTable.vue?vue&type=script&lang=ts"
import style0 from "./NeedsMealsTable.vue?vue&type=style&index=0&id=c08ca5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08ca5f6",
  null
  
)

export default component.exports